import { Resource } from '../interfaces/Resource'
import { PageQuery } from '../interfaces/PageQuery'
import { queryPage } from './queryPage'

/**
 * 获取文档对象。
 * @param db
 * @param collection
 * @param query
 */
export function getDocuments<T>(db: string, collection: string, query: PageQuery) {
	return queryPage<T>(`${db}/${collection}`, query)
}
